import Backbone from 'backbone';
import M from 'backbone.marionette'
import T from './punchSpecialiste.html'

import Radio from 'backbone.radio';
import { minutesToTimeString } from '../../../utils/utils';
import { SpecialistePunchList } from './specialistepunchlist';
import { SommaireBudget } from './sommairebudget';

export const PunchSpecialiste = M.View.extend({
    template: _.template(T),

    regions: {
        'punches':{
            el: '.punchesContainer'
        },
        'sommairebudget':{
            el: '.sommairebudget'
        }
    },
    initialize: function(){

        var initialData = this.$el.text();

        this.$el.text('');

        const data = JSON.parse(atob(initialData));
        
        this.initializeWidthData(data);

        Radio.channel('punch').on('save', this.onPunchSave, this);
        Radio.channel('punch').on('loadPunches', this.onLoadPunches, this);

    },
    initializeWidthData: function(data){
        
        const punches = new Backbone.Collection(data.punches.map(p => {
            return _.extend(p, {punchTimeString: minutesToTimeString(p.punchTimeInMinutes)})
        }));
        
        if(this.model){
            this.model.get('punches').reset(punches)
        }else{
            this.model = new Backbone.Model({
                budgets: new Backbone.Collection(data.budgets),
                punchreport_id: null,
                punches: punches,
                user: new Backbone.Model(data.user),
                loadedPunchReports: new Backbone.Collection(),
                punchTypes: new Backbone.Collection(data.punchTypes.map(p => {
                    return {id: p, label: p, value: p}
                })),
                punchreport: new Backbone.Model(data.punchreport)
            });
            this.model.get('punchreport').on('change taux', this.reRender.bind(this))
        }
        
        this.updateQuatities();
    },
    reRender: function(){
        console.log('RE RENDER')
        this.render();
    },
    onDestroy: function(){
        Radio.channel('punch').off('save', this.onPunchSave, this);
        Radio.channel('punch').off('loadPunches', this.onLoadPunches, this);
    },

    updateQuatities: function(){
        const nonTraites = this.model.get('punches').filter(p => !p.get('punchreport_id'))
        this.model.set({
            nbNonTraites: nonTraites.length,
            minNonTraites: minutesToTimeString(nonTraites.reduce((acc, curr) => { return acc + (curr.get('punchTimeInMinutes') ?? 0)}, 0)),
        })
    },
    
    onPunchSave: function(model){
        this.model.get('punches').add(model, {merge: true});
        this.updateQuatities();
        this.render();
    },
    onRender: function(){
        this.showChildView('punches', new SpecialistePunchList({
            model: this.model.get('punchreport'),
            mainModel: this.model,
            collection: this.model.get('punches'),
            childViewOptions: {
                mainModel: this.model
            }
        }))
        if(this.model.get('user').get('admin')){
            this.showChildView('sommairebudget', new SommaireBudget({
                model: this.model.get('punchreport'),
                mainModel: this.model,
            }))
        }
    },
    
})